import { useAtom } from 'jotai';

import { registerAtom, RegisterSchoolData } from '@/store';

// Este hook es utilizado para poder guardar data provicional de la registracion
const useRegistration = () => {
  const [registerData, setRegisterData] = useAtom(registerAtom);

  const handleSetRegisterData = (data: RegisterSchoolData) => {
    setRegisterData(data);
  };

  const handleResetRegisterData = () => {
    setRegisterData(null);
  };

  return {
    registerData,
    handleSetRegisterData,
    handleResetRegisterData,
  };
};

export default useRegistration;
